import { render, staticRenderFns } from "./ErrorDetails.vue?vue&type=template&id=e5af4fd6&"
import script from "./ErrorDetails.vue?vue&type=script&lang=ts&"
export * from "./ErrorDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports